import { categories } from "@/mocks/comics";

const colorMap: Record<string, { box: string; badge: string }> = {
  primary: { box: "bg-primary-100", badge: "bg-primary-500" },
  accent: { box: "bg-accent-100", badge: "bg-accent-500" },
  secondary: { box: "bg-secondary-100", badge: "bg-secondary-500" },
};

export default function Categories() {
  return (
    <section id="categories" className="w-full bg-background-100/60 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs text-accent-700">
            <i className="ri-menu-2-line"></i> 内容分类
          </span>
          <h2 className="mt-3 font-heading text-2xl text-foreground-950 md:text-4xl">
            想刷哪种乐子，随便挑
          </h2>
          <p className="mx-auto mt-2 max-w-xl text-sm text-foreground-600 md:text-base">
            按你的口味快速定位，沙雕日常、神吐槽、梗图段子、无厘头剧场，总有一款正中你的笑点。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {categories.map((cat) => {
            const c = colorMap[cat.color] || colorMap.primary;
            return (
              <article
                key={cat.id}
                className="overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition-transform duration-300 hover:-translate-y-1"
              >
                <div className="relative aspect-square w-full overflow-hidden">
                  <img
                    src={cat.icon}
                    alt={`韩国歪歪漫画-${cat.name}分类`}
                    title={`${cat.name}-搞笑分类`}
                    className="h-full w-full object-cover object-top"
                  />
                  <span
                    className={`absolute left-3 top-3 rounded-full ${c.badge} px-3 py-1 text-xs text-background-50`}
                  >
                    {cat.count}
                  </span>
                </div>
                <div className="p-4 md:p-5">
                  <div className="flex items-center justify-between">
                    <h3 className="font-heading text-lg text-foreground-950">{cat.name}</h3>
                    <span className="text-xs text-foreground-500">{cat.en}</span>
                  </div>
                  <p className="mt-1.5 text-sm text-foreground-600">{cat.desc}</p>
                  <a
                    href="#memes"
                    className="mt-4 inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700"
                  >
                    进入专区 <i className="ri-arrow-right-line"></i>
                  </a>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}